import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-testlanding',
  templateUrl: './testlanding.component.html',
  styleUrls: ['./testlanding.component.css']
})
export class TestlandingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
